
import { Component, Vue } from 'vue-property-decorator'

/**
 * テーブルタグの基底コンポーネント
 */
@Component
export default class TableBase extends Vue {}
